import { Violation, ViolationSeverity } from '../../validation';

export class NonUniqueModelDataError extends Violation {
    public constructor(message: string) {
        super(ViolationSeverity.Error, message);
    }
}
